/* eslint-disable no-unused-vars */
export enum CERTIFICATE_TONE {
  FORMAL = "formal",
  INFORMAL = "informal",
}

export enum CERTIFICATE_LANG {
  FA = "fa",
  EN = "en",
}

export enum CERTIFICATE_DETAIl {
  WITH_EMOJI = "with_emoji",
  WITH_COURSE_TITLE = "without_course_title",
}

export enum SHARE_CERTIFICATE_STEP {
  SELECT = "select",
  CONFIG = "config",
  LOADING = "loading",
}

export enum CREATE_CERTIFICATE_MODE {
  MODAL = "modal",
  PAGE = "page",
}

export enum CREATE_CERTIFICATE_STEP {
  CONFIG = "config",
  LOADING = "loading",
}

export enum CERTIFICATE_STEP {
  CONFIG = "config",
  ADD_PROFILE = "add-profile",
  SUCCESS = "success",
}
